import React from 'react';
import {connect} from 'react-redux';

import Header from './header';

import PerfectScrollbar from 'react-perfect-scrollbar'
import ModalWindow from 'shared/components/ModalWindow.jsx';
import VerifyModal from 'shared/components/VerifyModal/VerifyModal.jsx';
import Join from './Join.jsx';
import SignIn from './SignIn.jsx';
import CreatePassword from 'shared/components/CreatePassword';
import PasswordRecovery from './PasswordRecovery.jsx';

import * as JoinStage from 'constants/JoinStage';
import * as CreatePasswordStage from 'constants/CreatePasswordStage';
import { resourceNames } from 'constants/accountResourceNames';

import {loadAuth as loadAuthAction} from 'actions/auth/loadAuthAction';
import {initCreatePassword as initCreatePasswordAction} from 'actions/creators/createPassword';
import {beginSignIn as beginSignInAction} from 'actions/creators/Auth';

import * as cookie from 'cookie-utils';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
    password: {
        id: 'create-password.modla-title',
        defaultMessage: 'Придумайте пароль'
    }
});

import * as ruMessages from './grid-control/localization/ru';
import * as enMessages from './grid-control/localization/en';
import * as uzMessages from './grid-control/localization/uz';
import * as kkMessages from './grid-control/localization/kk';

import * as Languages from '../../constants/Language';

const localeMap = {
    [Languages.RU]: ruMessages,
    [Languages.EN]: enMessages,
    [Languages.UZ]: uzMessages,
    [Languages.KK]: kkMessages,
};

class Application extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        user: React.PropTypes.any,
        freebet: React.PropTypes.any,
        balance: React.PropTypes.any,
        newMessagesCount: React.PropTypes.number,
        joinStage: React.PropTypes.number.isRequired,
        signInOngoing: React.PropTypes.bool.isRequired,
        userGridSelection: React.PropTypes.object.isRequired,
        domain: React.PropTypes.string.isRequired,
        sportId: React.PropTypes.any,
        leagueId: React.PropTypes.any,
        passwordRecoveryOngoing: React.PropTypes.bool.isRequired,
        main: React.PropTypes.any,
        footer: React.PropTypes.any,
        loadAuthAction: React.PropTypes.func.isRequired,
        initCreatePasswordAction: React.PropTypes.func.isRequired
    };

    static childContextTypes = {
        toggleMenu: React.PropTypes.func,
        footer: React.PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this._timeoutId = null;

        this.onModalClose = this.onModalClose.bind(this);

        this.state = {isShortcut: false};
    }

    getChildContext() {
        return {
            toggleMenu: this.toggleMenu.bind(this),
            footer: this.props.footer
        };
    }

    componentWillMount() {
        const user = this.props.user;

        if (!user && cookie.getCookie('token')) {
            this.props.loadAuthAction();
        }
    }

    componentDidMount = () => {
        window.beginSignIn = this.props.beginSignInAction
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.user !== nextProps.user) {
            this._timeoutId = window.setTimeout(() => {
                if (nextProps.user) {
                    const user = nextProps.user;
                    if (window.jivo_api) {
                        window.jivo_api.setContactInfo({
                            'name': user.get('login')
                        });

                        window.jivo_api.setCustomData([{
                            'content': `ID ирока: ${user.get('gamblerId')}, Лицевой счет: ${user.get('accountNum')}, логин: ${user.get('login')}, валюта: ${resourceNames[user.get('resourceId')]}`,
                        }]);
                    }
                } else {
                    if (window.jivo_api) {
                        window.jivo_api.setContactInfo({});
                        window.jivo_api.setCustomData([]);
                    }
                }
            }, 3000);
        }
    }

    componentWillUnmount() {
        if (this._timeoutId !== null) {
            window.clearTimeout(this._timeoutId);
        }
    }

    toggleMenu() {
        const {isShortcut} = this.state;

        this.setState({isShortcut: !isShortcut});
    }

    onModalClose() {
        this.props.initCreatePasswordAction();
    }

    render() {
        const {
            languageId, user, freebet, balance, newMessagesCount, userGridSelection, countryCode,
            signInOngoing, joinStage, passwordRecoveryOngoing, domain, sportId, leagueId, footer, passwordStage
        } = this.props;

        const {isShortcut} = this.state;

        const localeStrings = localeMap[languageId];

        const gridLocalization = {
            ...localeStrings,
            languageId
        };

        const cls = (footer !== undefined) ? '' : (isShortcut ? 'shortcut-menu' : '');

        const headerProps = {
            languageId,
            user,
            gamblerId: user ? user.get('gamblerId') : null,
            freebet: (freebet === undefined ? null : freebet),
            balance,
            newMessagesCount,
            userGridSelection,
            domain,
            sportId,
            leagueId,
            countryCode
        };

        const withProps = React.cloneElement(this.props.main, {gridLocalization, isShortcut});

        if (window.location.pathname.includes('games') || countryCode === 'KG') {
            return (
                <div style={{minWidth: '1280px'}}>
                    <VerifyModal />
                    <Header {...headerProps}/>

                    <div id="wrapper" className={cls}>
                        <div id="page-wrap">
                            {withProps}
                        </div>
                    </div>

                    {joinStage !== JoinStage.NONE && <ModalWindow><Join/></ModalWindow>}
                    {signInOngoing && <ModalWindow><SignIn/></ModalWindow>}
                    {passwordRecoveryOngoing && <ModalWindow><PasswordRecovery/></ModalWindow>}
                    {passwordStage === CreatePasswordStage.INIT && <ModalWindow>
                        <div className='modal modal--auth modal--auth-login modal__visible modal--create-password'>
                            <div className='modal--dialog'>
                                <div className='modal--header'>
                                    <div className='header-inner--logotype__link'/>
                                    <div className='header-inner__title'>
                                        <FormattedMessage {...messages.password} />
                                    </div>
                                    <button className='modal__close modal__close__green modal__close__js' onClick={this.onModalClose} />
                                </div>
                                <div className='modal--content'>
                                    <CreatePassword passwordStage={passwordStage}/>
                                </div>
                            </div>
                        </div>
                    </ModalWindow>}
                </div>
            )
        }

        return (
            <PerfectScrollbar>
                <VerifyModal />
                <div style={{minWidth: '1280px'}}>
                    <Header {...headerProps}/>

                    <div id="wrapper" className={cls}>
                        <div id="page-wrap">
                            {withProps}
                        </div>
                    </div>

                    {joinStage !== JoinStage.NONE && <ModalWindow><Join/></ModalWindow>}
                    {signInOngoing && <ModalWindow><SignIn/></ModalWindow>}
                    {passwordRecoveryOngoing && <ModalWindow><PasswordRecovery/></ModalWindow>}
                    {passwordStage === CreatePasswordStage.INIT && <ModalWindow>
                        <div className='modal modal--auth modal--auth-login modal__visible modal--create-password'>
                            <div className='modal--dialog'>
                                <div className='modal--header'>
                                    <div className='header-inner--logotype__link'/>
                                    <div className='header-inner__title'>
                                        <FormattedMessage {...messages.password} />
                                    </div>
                                    <button className='modal__close modal__close__green modal__close__js' onClick={this.onModalClose} />
                                </div>
                                <div className='modal--content'>
                                    <CreatePassword passwordStage={passwordStage}/>
                                </div>
                            </div>
                        </div>
                    </ModalWindow>}
                </div>
            </PerfectScrollbar>
        );
    }
}

function select(state, props) {
    const languageId = state.application.get('languageId');
    const countryCode = state.application.get('countryCode');
    const user = state.auth.get('user');
    const freebet = state.application.getIn(['coupon', 'freebet']);
    const balance = state.balance.get('value');
    const newMessagesCount = state.application.getIn(['messages', 'newMessagesCount']);
    const joinStage = state.join.get('stage');
    const passwordStage = state.createPassword.stage;
    const signInOngoing = state.auth.get('signInOngoing');
    const passwordRecoveryOngoing = state.passwordRecovery.get('isOngoing');
    const domain = state.domain;
    const userGridSelection = state.application.getIn(['userGridSelection', 'preMatch']);

    const sportId = props.params.sportId;
    const leagueId = props.params.leagueId;

    return {
        countryCode,
        languageId,
        user,
        freebet,
        balance,
        newMessagesCount,
        joinStage,
        passwordStage,
        signInOngoing,
        passwordRecoveryOngoing,
        userGridSelection,
        domain,
        sportId,
        leagueId
    };
}

export default connect(select, {loadAuthAction, initCreatePasswordAction, beginSignInAction})(Application);



// WEBPACK FOOTER //
// ./js/sport-betting/components/Application.jsx